<div nz-row>
  <div nz-col nzXs="24" nzMd="6" class="product_image">
    <img src="{{imageUrl}}">
  </div>
  <div nz-col nzXs="24" nzMd="18">
    <div class="product-info">
      <div class="product-details" [innerHtml]="catalogueItem.description"></div>
      <hr class="light-hr">
      <div class="specs-row specs-row-first" nz-row nzType="flex" nzJustify="space-between">
        <div nz-col nzSpan="8">Quantity:</div>
        <div nz-col nzSpan="12" class="product_quantity">
          <app-quantity-input [modelField]="(cartItem$ | async)?.quantity"
            [isProduct]="true"
            [isProductInCart]="isItemInCart$ | async"
            id="CheckoutQuantity{{catalogueItem.name | replaceStr}}"
            [sampling]="cartSampling"
            (modelFieldChange)="quantityChanged($event)">
          </app-quantity-input>
        </div>
      </div>
      <div class="specs-row" nz-row nzType="flex" nzJustify="space-between">
        <div nz-col nzSpan="8">Price:</div>
        <div nz-col nzSpan="12" class="product_price">
          {{catalogueItem.price.amount | currency:'NZD':'symbol-narrow'}}
        </div>
      </div>
      <div class="specs-row" nz-row nzType="flex" nzJustify="space-between">
        <div nz-col nzSpan="8">Order Total:</div>
        <div nz-col nzSpan="12" class="product_total-price">
          {{
          orderTotal | currency:cartItem?.quantityPrice?.currency:'symbol-narrow'}}
          excl. GST
        </div>
      </div>
      <ng-container *ngTemplateOutlet="footerActions"></ng-container>
    </div>
  </div>
</div>
<ng-template #footerActions>
  <ng-container *ngIf="isSampling(catalogueItem)">
    <div nz-row>
      <div nz-col nzSpan="24" class="footer-actions">
        <button nz-button nzType="primary"
          id="add-to-cart-button"
          [nzLoading]="addingItemToCart$ | async"
          (click)="addItemToCart()">{{ (isItemInCart$ | async) ? 'Update Cart' : 'Add to Cart'}}
        </button>
      </div>
    </div>
  </ng-container>
</ng-template>
